import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { GetEnumValuesDto, OutBoxStatus } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { OutBoxMessagesService } from '../../../../core/api/services';
import { DialogService } from '../../../../core/services/dialog.service';
import { DynamicTableService } from '../../../../core/services/dynamic-table.service';
import { TranslationService } from '../../../../i18n/translation.service';

@Component({
    selector: 'app-outbox-messages-edit-status.',
    templateUrl: './outbox-messages-edit-status.component.html',
    styleUrls: ['./outbox-messages-edit-status.component.scss'],
    standalone: false
})
export class OutboxMessagesEditStatusComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  scheduledMessageId: number;
  status: OutBoxStatus;
  currentStatus: OutBoxStatus;
  OutBoxStatusEnumValues: GetEnumValuesDto[] = [];
  get OutBoxStatus() {
    return OutBoxStatus;
  }

  //#endregion
  constructor(
    public translationService: TranslationService,
    protected currentService: OutBoxMessagesService,
    public dialogService: DialogService,

    public dynamicTableService: DynamicTableService,
    private dialogRef: MatDialogRef<OutboxMessagesEditStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    if (data) {
      this.scheduledMessageId = data.scheduledMessageId;
      this.currentStatus = data.status;
      this.OutBoxStatusEnumValues = data.OutBoxStatusEnumValues;
    }
  }

  ngOnInit() {
    this.initForm();
    this.formPageConfig.title = 'common.editStatus';
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  //#region init

  initForm() {
    this.form = new FormGroup({
      status: new FormControl('', Validators.required),
      currentStatus: new FormControl(''),
    });
    try {
      this.form.controls['currentStatus'].disable();
      this.form.get('currentStatus').updateValueAndValidity();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  //#endregion

  //#region Api

  outBoxMessagesUpdateStatusApi() {
    this.unSubs();
    this.loading = true;

    this.currentService
      .outBoxMessagesUpdateStatusPut({
        body: { id: this.scheduledMessageId, status: this.status },
        id: this.scheduledMessageId,
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.loading) return;
    this.outBoxMessagesUpdateStatusApi();
  }

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }

  unSubs() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
